import { LocalizationService } from '../services/localization.service';
import { Drink } from 'src/interfaces/drink.model';
import { Food } from 'src/interfaces/food.model';

/** Слова запроса: без регистра, «ё» = «е» */
export function queryWords(query: string): string[] {
  return normalize(query).split(/\s+/).filter(Boolean);
}

/** Все слова запроса — в названии или описании (на языке гостя и исходных) */
export function matchesQuery(item: Food | Drink, words: string[], localization: LocalizationService): boolean {
  const text = normalize([
    localization.getFieldForItem(item, 'title'),
    localization.getFieldForItem(item, 'description'),
    item.title,
    item.description,
  ].join(' '));
  return words.every((word) => text.includes(word));
}

function normalize(value: string): string {
  return (value ?? '').toLowerCase().replace(/ё/g, 'е').trim();
}
